import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import { DatePicker, IDatePickerProps } from '@fluentui/react'
import { listTextFieldStyles } from './TextField/List/ListTextField'
import { formatFullNumericDate, formatIsoDate, formatShortNumericDate, parseDate } from '../helpers/dateHelper'
import { defaultDatePickerProps } from './DatePicker/LocalDatePicker'
import { useTranslation } from 'react-i18next'

export type LocalDatePickerProps = {
    datePickerProps?: IDatePickerProps
    isListColumn?: boolean
    value?: string
    onSelectDate?: (isoDate: string) => void
}

const defaultListProps: Partial<IDatePickerProps> = {
    textField: {
        underlined: true,
        styles: listTextFieldStyles,
    },
    styles: {
        icon: { fontSize: '12px', padding: '3px 0px' },
        callout: { marginLeft: '-4px' },
        textField: { textAlign: 'right' },
    },
    formatDate: formatShortNumericDate,
    parseDateFromString: (date: string) => DateTime.fromFormat(date, 'd-M').toBSON(),
}

const defaultFormProps: Partial<IDatePickerProps> = {
    label: 'Datum',
    isRequired: true,
    formatDate: formatFullNumericDate,
    parseDateFromString: (date: string) => DateTime.fromFormat(date, 'd-M-yy').toBSON(),
}

export default function LocalDatePicker(props: LocalDatePickerProps): ReactElement {
    const { t: translate } = useTranslation()

    const [value, setValue] = useState<Date>(null)

    useEffect(() => {
        setValue(parseDate(props.value)?.toBSON() ?? value)
    }, [props.value])

    const allProps = { ...defaultDatePickerProps, ...props.datePickerProps }

    return (
        <DatePicker
            {...(props.isListColumn ? defaultListProps : defaultFormProps)}
            {...allProps}
            placeholder={translate(allProps.placeholder)}
            value={value}
            onSelectDate={(date: Date) => {
                props.onSelectDate?.(formatIsoDate(date))
            }}
        />
    )
}
